import { useState } from "react";

const useStudentToAdd = () => {
	const [studentToAdd, setStudentToAdd] = useState({
		id: "",
		toastId: "",
		name: "",
	});
	const changeField = id => {
		id = id.toUpperCase();
		setStudentToAdd({
			...studentToAdd,
			id: id,
			name: "",
		});
	};
	const clearStudentId = () => {
		setStudentToAdd(prev => ({
			...prev,
			id: "",
		}));
	};
	const clearStudentName = () => {
		setStudentToAdd(prev => ({
			...prev,
			name: "",
		}));
	};
	const fillForToast = studentName => {
		setStudentToAdd(prev => ({
			...prev,
			toastId: prev.id,
			name: studentName,
		}));
	};
	return {
		value: studentToAdd,
		changeField,
		clearStudentId,
		clearStudentName,
		fillForToast,
	};
};

export default useStudentToAdd;
